document.addEventListener('DOMContentLoaded', function () {
    const $ = window.jQuery;

    // Ne pas afficher le bouton "voir le panier" après ajout au panier en ajax
    // https://www.businessbloomer.com/woocommerce-hide-view-cart-button-upon-ajax-add-to-cart/
    $(document.body).on('wc_cart_button_updated', function () {
        $('.added_to_cart.wc-forward').remove();
    });

    // Mettre à jour le compteur panier du header avec animation + afficher la popup de notification
    $(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
        var count = parseInt($('#site-header .cart-count').text());
        count++; console.log(count);
        $('#site-header .cart-count').text(count);
        $('#site-header .cart-count').addClass('scale-up');
        setTimeout(function() {
            $('#site-header .cart-count').removeClass('scale-up');
        }, 800); // le double des 400ms de durée de l'animation keyframes "bump"

        injectAddedToCartNotice($button);
    });

    /**
     * Injecte une notice WooCommerce dans le DOM pour déclencher la popup de notification.
     * Le MutationObserver de _wc-notices-popup.js la détecte et ouvre la popup.
     * @param {jQuery} $button - Le bouton "ajouter au panier" cliqué
     */
    function injectAddedToCartNotice($button) {
        // Récupérer le nom du produit depuis le contexte DOM
        let productName = '';
        if ($button && $button.length) {
            const $item = $button.closest('.accessory-item');
            if ($item.length) {
                productName = $item.find('h3').first().text().trim();
            }
        }

        // Récupérer l'URL du panier
        const cartUrl = (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.cart_url)
            ? wc_add_to_cart_params.cart_url
            : (document.querySelector('[data-popup="wc-notices"]')?.dataset.cartUrl ?? '#');

        // Créer le wrapper et la notice au format WooCommerce standard
        const wrapper = document.createElement('div');
        wrapper.className = 'woocommerce-notices-wrapper';

        const notice = document.createElement('div');
        notice.className = 'woocommerce-message';
        notice.setAttribute('role', 'alert');

        // Lien wc-forward (masqué via CSS dans la popup, mais nécessaire pour déclencher le système d'extras)
        const cartLink = document.createElement('a');
        cartLink.href = cartUrl;
        cartLink.className = 'button wc-forward';
        cartLink.textContent = (typeof wc_add_to_cart_params !== 'undefined' && wc_add_to_cart_params.i18n_view_cart)
            ? wc_add_to_cart_params.i18n_view_cart
            : 'Voir le panier';

        const noticeText = productName
            ? `\u00ab\u00a0${productName}\u00a0\u00bb a été ajouté à votre panier.`
            : 'Le produit a été ajouté à votre panier.';

        notice.appendChild(cartLink);
        notice.appendChild(document.createTextNode(' ' + noticeText));
        wrapper.appendChild(notice);

        // L'injection déclenche le MutationObserver de _wc-notices-popup.js
        document.body.appendChild(wrapper);
    }
});